import type { PortalRole } from '../types/portalUser';

export const canWriteStudentObservations = (roles: PortalRole[]): boolean =>
  roles.includes('admin') || roles.includes('coach') || roles.includes('support');
